import styled from 'styled-components';

export const StyledMetaNav = styled.nav`
  align-items: center;
  display: flex;
  gap: 4rem;
  height: 100%;
`;
